<template>
	<div class="form-content-composer-options-auto-complete">
    <form-input
        :label="$t('form_content_composer.options_input.label.changeValues')"
        :value="value.changeValues"
        :required="true"
        @input="onInput('changeValues', $event)"
    />
    <form-input
        :label="$t('form_content_composer.options_input.label.changeDataSet')"
        :value="value.changeDataSet"
        :required="true"
        @input="onInput('changeDataSet', $event)"
    />
    <form-input
        :label="$t('form_content_composer.options_input.label.cancelChanges')"
        :value="value.cancelChanges"
        :required="true"
        @input="onInput('cancelChanges', $event)"
    />
	</div>
</template>

<script>
import _set from 'lodash/set'
import _cloneDeep from 'lodash/cloneDeep'

import FormInput from '@pixelstein/ps-form/components/PsFormInput'

export default {
  name: 'FormContentComposerOptionsAutoComplete',
  components: { FormInput },
  props: {
    value: { type: Object, default: () => ({ values: [] }) },
  },
  methods: {
    onInput (path, value) {
      console.log('onInput', path, value)
      const valueClone = _cloneDeep(this.value)
      _set(valueClone, path, value)

      this.$emit('input', valueClone)
    },
  },
}
</script>
